import { StrikeZoneLocation } from 'interfaces/session/IStrikeZoneDefinition';

export interface IPlaneDefinition {
  locationType: StrikeZoneLocation;
  label: string;
  description: string;
  hasAdjustments: boolean;
  testId: string;
}

export const PLANE_DEFINITIONS: IPlaneDefinition[] = [
  {
    locationType: StrikeZoneLocation.Front,
    label: 'Front',
    description: 'Pitches are evaluated at the front edge of the home plate',
    hasAdjustments: false,
    testId: 'front',
  },
  {
    locationType: StrikeZoneLocation.Middle,
    label: 'Middle',
    description: 'Pitches are evaluated at the middle of the home plate',
    hasAdjustments: true,
    testId: 'middle',
  },
  {
    locationType: StrikeZoneLocation.Back,
    label: 'Back',
    description: 'Pitches are evaluated at the back edge of the home plate',
    hasAdjustments: true,
    testId: 'back',
  },
];
